import styled from 'styled-components';


export const InfoSec = styled.section`
    color: #fff;
    padding: clamp(40px, 7vw, 90px) 0;
    background: ${({lightBg}) => (lightBg ? '#001d07' : '#a1ff71')};
    overflow: hidden;
`

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: clamp(24px, 4vw, 56px);

  @media screen and (min-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  justify-content: center;
  min-width: 0;

  /* No mobile a imagem aparece primeiro, chamando atenção para o produto */
  order: ${({ $isImage }) => ($isImage ? -1 : 0)};

  @media screen and (min-width: 900px) {
    order: ${({ $isImage, $imgStart }) =>
      $isImage === Boolean($imgStart) ? -1 : 0};
    justify-content: ${({ $isImage, $start }) =>
      $isImage ? ($start ? 'flex-start' : 'flex-end') : 'flex-start'};
  }
`;

export const TextWrapper = styled.div`
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media screen and (min-width: 900px) {
    align-items: flex-start;
    text-align: left;
  }
`;

export const ImgWrapper = styled.div`
  width: 100%;
  max-width: 555px;
  display: flex;
  justify-content: center;
`;

export const TopLine = styled.div`
  display: inline-block;
  color: ${({ lightTopLine }) => (lightTopLine ? '#fff' : '#001d07')};
  background: ${({ lightTopLine }) => (lightTopLine ? '#1E8BB8' : '#a1ff71')};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 18px;
`;

export const Img = styled.img`
  border: 0;
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
  vertical-align: middle;
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.18));

  @media screen and (max-width: 899px) {
    max-height: 340px;
  }

  @media screen and (max-width: 600px) {
    max-height: 260px;
  }
`;

export const Heading = styled.h1`
  margin-bottom: 20px;
  font-size: clamp(28px, 4.2vw, 48px);
  line-height: 1.15;
  font-weight: 700;
  color: ${({ lightText }) => (lightText ? '#002c03' : '#fff')};
`;

export const Subtitle = styled.p`
  max-width: 500px;
  margin-bottom: 32px;
  font-size: clamp(16px, 1.6vw, 19px);
  line-height: 1.6;
  font-weight: 600;
  color: ${({ lightTextDesc }) => (lightTextDesc ? '#002c03' : '#e6f5e8')};
`;
